import { RootState } from '@/store'
import { isRequestPending } from '@/store/selectors'

import {
  FETCH_PUBLISHER_ANALYTICS,
  FETCH_PUBLISHER_NOTIFICATION_LOGS,
  FETCH_SYSTEM_CONNECTOR_ACTIVITY
} from './actionTypes'

export const getDeviceMetrics = (state: RootState) => {
  return {
    metrics: (state.spacePublisherLogsPage && state.spacePublisherLogsPage.deviceMetrics) || {},
    isLoading: isRequestPending(state, [FETCH_PUBLISHER_ANALYTICS])
  }
}

export const getPublisherMetrics = (state: RootState) => {
  return {
    metrics: (state.spacePublisherLogsPage && state.spacePublisherLogsPage.publisherMetrics) || {},
    isLoading: isRequestPending(state, [FETCH_SYSTEM_CONNECTOR_ACTIVITY])
  }
}

export const getPreviousPublisherMetrics = (state: RootState) => {
  return {
    metrics: (state.spacePublisherLogsPage && state.spacePublisherLogsPage.previousPublisherMetrics) || {},
    isLoading: isRequestPending(state, [FETCH_SYSTEM_CONNECTOR_ACTIVITY])
  }
}

export const getGeneratedCSVUrls = (state: RootState) => {
  return {
    urls: (state.spacePublisherLogsPage && state.spacePublisherLogsPage.generatedCSVUrls) || undefined,
    isLoading: isRequestPending(state, [FETCH_PUBLISHER_NOTIFICATION_LOGS])
  }
}
